import Swiper from "swiper";
import { initIntersectionObserver } from "@plugins";

const thumbsSliderContainer = document.querySelector(".js-benefits-thumbs-thumbs");
const slidesContainer = document.querySelector(".js-benefits-thumbs-slider");

if (thumbsSliderContainer && slidesContainer) {
    initIntersectionObserver(slidesContainer, initBenefitsThumbsSlider);
}

function initBenefitsThumbsSlider() {
    const thumbsPerViewCount = thumbsSliderContainer.dataset.thumbsPerView || 3;

    const benefitsThumbsSwiper = new Swiper(thumbsSliderContainer, {
        spaceBetween: 24,
        slidesPerView: thumbsPerViewCount,
        observer: true,
        shortSwipes: false,
        watchOverflow: true,
    });

    new Swiper(slidesContainer, {
        spaceBetween: 10,
        navigation: {
            nextEl: ".js-benefits-thumbs-controls .swiper-button-next",
            prevEl: ".js-benefits-thumbs-controls .swiper-button-prev",
        },
        pagination: {
            el: ".js-benefits-thumbs-controls .swiper-pagination",
            dynamicBullets: true,
            dynamicMainBullets: 3,
            clickable: true,
        },
        thumbs: {
            swiper: benefitsThumbsSwiper,
        },
    });
}
